import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", { d: "M11.5093 0.366815L13.7412 7.19876C13.8129 7.41783 14.0176 7.56558 14.2479 7.56558H21.4656C21.9826 7.56558 22.1976 8.22279 21.7779 8.52847L15.9372 12.752C15.7479 12.8895 15.671 13.1289 15.7427 13.348L17.9745 20.1799C18.1332 20.669 17.5702 21.0766 17.1504 20.7761L11.3098 16.5526C11.1203 16.415 10.8695 16.415 10.6801 16.5526L4.83939 20.7761C4.41964 21.0766 3.85655 20.669 4.01525 20.1799L6.2471 13.348C6.31876 13.1289 6.24198 12.8895 6.05258 12.752L0.222116 8.52847C-0.197635 8.22788 0.0173594 7.56558 0.534371 7.56558H7.75206C7.98242 7.56558 8.18717 7.41783 8.25883 7.19876L10.4958 0.366815C10.6545 -0.122272 11.3506 -0.122272 11.5145 0.366815H11.5093Z" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", null, [
    (_openBlock(), _createElementBlock("svg", {
      width: "22",
      height: "21",
      viewBox: "0 0 22 21",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      class: _normalizeClass({
        'text-cebai-primary fill-current hover:opacity-70': _ctx.starred,
        'text-cebai-grey-mid fill-current hover:text-cebai-grey-dark hover:opacity-50':
          !_ctx.starred,
      })
    }, _hoisted_2, 2))
  ]))
}